import { get, toLower, upperFirst } from 'lodash';

const EndpointStatus = {
  active: 'active',
  inactive: 'inactive',
  pending_activation: 'pending',
  unknown: 'unknown',
};

const deviceTypeFromEnrollment = (endpoint = {}) => {
  const make = upperFirst(get(endpoint, 'device.make', ''));
  const model = get(endpoint, 'device.model', '');

  return `${make} ${model}`.trim();
};

const formatOS = (device = {}) => {
  const make = get(device, 'make', '');
  const os = get(device, 'os', '');

  return toLower(make) === 'apple'
    ? 'iOS'
    : upperFirst(os);
};

const getOSFromEnrollment = (endpoint = {}) => {
  const os = formatOS(get(endpoint, 'device'));
  const version = get(endpoint, 'device.osVersion', '');

  return `${os} ${version}`.trim();
};

const validateDates = (endpoint = {}, dateField = '') => {
  const dateValue = new Date(get(endpoint, dateField));

  return dateValue.toString() === 'Invalid Date'
    ? dateValue.toString()
    : dateValue;
};

const PushEndpointDevice = {
  fromApi: (device = {}) => ({
    appVersion: device.appVersion,
    make: device.make,
    model: device.model,
    os: device.os,
    osVersion: device.osVersion,
    uvEnabled: device.uvEnabled,
  }),
};

const PushEndpoint = {
  fromApi: (endpoint = {}) => ({
    device: PushEndpointDevice.fromApi(endpoint.device),
    deviceType: deviceTypeFromEnrollment(endpoint),
    displayName: get(endpoint, 'name', ''),
    status: EndpointStatus[toLower(endpoint.state)] || EndpointStatus.unknown,
    isActivationPending:
      EndpointStatus[toLower(endpoint.state)] === EndpointStatus.pending_activation,

    id: endpoint.id,
    os: getOSFromEnrollment(endpoint),

    lastUsedDate: validateDates(endpoint, 'lastUsedDate'),
    enrollmentDate: validateDates(endpoint, 'enrollmentDate'),
  }),
};

export default PushEndpoint;
